import { DEFAULT_EMPTY_UUID } from 'utils'

export const getResourceItemFromList = (id, list, currentResourceTypeName) => {
    let item = null

    switch (currentResourceTypeName) {
        case 'BusinessRoles':
        case 'Mailboxes':
        case 'AzureRoles':
        case 'SharedFolders':
            item = list?.find(
                (i) =>
                    i.assignment.resourceAssignment.resourceAssignmentId === id,
            )
            break
        case 'Computers':
            item = list.find((i) => i.resource?.id.toString() === id)
            if (!item) {
                item = list?.find(
                    (i) =>
                        i.assignment?.resourceAssignment
                            ?.resourceAssignmentId === id,
                )
            }
            break
        default:
            item = list.find((i) => i.resource.id.toString() === id)
            break
    }

    return item
}

export const getUniqueId = (item, tab = null) => {
    if (
        tab === 'loginsession' ||
        tab === 'history' ||
        tab === 'appManagementRoles'
    ) {
        return item.resource.id
    }

    if (!item?.resource?.id && item?.id) {
        return item.id
    }

    switch (item.resource.resourceTypeName) {
        
        case 'AzLocalRight':
            if(item?.resource?.id) {  
                return item.resource.id
            }else{
                return `${item.resource?.localRightId}:${item.resource?.assigneeId}`
            }
        case 'BusinessRole':
        case 'Computer':
            return item.assignment.resourceAssignment.resourceAssignmentId
        
        default:
            return item.resource.id
    }
}


export const setResourceTypeQueryParams = (query, item) => {
    if (
        item?.resource?.resourceTypeName === 'ApplicationRole' &&
        item?.resource?.accountId
    ) {
        query.set('accountId', item?.resource?.accountId)
    }
    if (
        item?.resource?.resourceTypeName === 'MailBox' &&
        item?.assignment?.resourceAssignment?.resourceAssignmentId
    ) {
        query.set(
            'assignmentId',
            item?.assignment?.resourceAssignment?.resourceAssignmentId,
        )
    }
    if (
        item?.resource?.resourceTypeName === 'AzureRole' &&
        item?.assignment?.resourceAssignment?.resourceAssignmentId &&
        item?.assignment?.resourceAssignment?.resourceAssignmentId !==
            DEFAULT_EMPTY_UUID
    ) {
        query.set(
            'assignmentId',
            item?.assignment?.resourceAssignment?.resourceAssignmentId,
        )
    }
    if (
        item?.resource?.resourceTypeName === 'SharedFolder' &&
        item?.assignment?.resourceAssignment?.resourceAssignmentId
    ) {
        query.set(
            'assignmentId',
            item?.assignment?.resourceAssignment?.resourceAssignmentId,
        )
    }
}
